// extracted by mini-css-extract-plugin
export default {"Movable":"ListMovable_Movable__oDWtJ","MovableList":"ListMovable_MovableList__2yOOU","MovableItem":"ListMovable_MovableItem__L1BGM"};